import type {
  CompleteReturnRequest,
  CompleteReturnResponse,
  CreateMaintenanceRequest,
  CreateMaintenanceResponse,
  ListActiveCustomersResponse,
  SetReturnDateResponse,
} from '@bhops/shared';
import { apiClient } from './client';

// S3 §3.5 — 활성 고객사 관리 탭 typed client.
//
//   list()           GET    /active-customers
//   createMaintenance POST  /active-customers/:customerId/maintenance
//   setReturnDate()  PATCH  /active-customers/:customerId/return-date

export const activeCustomersApi = {
  async list(): Promise<ListActiveCustomersResponse> {
    const { data } = await apiClient.get<ListActiveCustomersResponse>('/active-customers');
    return data;
  },

  async createMaintenance(
    customerId: string,
    body: CreateMaintenanceRequest,
  ): Promise<CreateMaintenanceResponse> {
    const { data } = await apiClient.post<CreateMaintenanceResponse>(
      `/active-customers/${customerId}/maintenance`,
      body,
    );
    return data;
  },

  // returnScheduledAt = null → 회수일 확정 해제.
  async setReturnDate(
    customerId: string,
    returnScheduledAt: string | null,
  ): Promise<SetReturnDateResponse> {
    const { data } = await apiClient.patch<SetReturnDateResponse>(
      `/active-customers/${customerId}/return-date`,
      { returnScheduledAt },
    );
    return data;
  },

  // R2 #7 (plan G-3.4) — 회수 완료: 로봇 정비(IN_AS)/폐기(RETIRED) 전이 +
  // 마지막 로봇이면 고객사 retired.
  async completeReturn(
    customerId: string,
    body: CompleteReturnRequest,
  ): Promise<CompleteReturnResponse> {
    const { data } = await apiClient.post<CompleteReturnResponse>(
      `/active-customers/${customerId}/complete-return`,
      body,
    );
    return data;
  },
};
